import { useToast } from 'primevue/usetoast'
import { useI18n } from 'vue-i18n'

const SUCCESS_DURATION = 5000
const WARNING_DURATION = 15000
const ERROR_DURATION = 15000
const INFO_DURATION = 5000

export function useDssToast() {
  let toast
  const { t } = useI18n()

  try {
    toast = useToast()
  }
  catch (event) {
    console.warn('Toast service not available, falling back to console', event)

    return {
      success: (title, message) => console.warn(title, message),
      warning: (title, message) => console.warn(title, message),
      error: (title, message) => console.error(title, message),
      info: (title, message) => console.warn(title, message),
    }
  }

  function success(
    title = 'messages.success.title',
    message = 'messages.success.message',
    duration = SUCCESS_DURATION,
  ) {
    toast.add({
      severity: 'success',
      summary: t(title),
      detail: t(message),
      life: duration,
    })
  }

  function warning(
    title = 'messages.warning.title',
    message = 'messages.warning.message',
    duration = WARNING_DURATION,
  ) {
    toast.add({
      severity: 'warning',
      summary: t(title),
      detail: t(message),
      life: duration,
    })
  }

  function error(
    title = 'messages.error.title',
    message = 'messages.error.message',
    duration = ERROR_DURATION,
  ) {
    toast.add({
      severity: 'error',
      summary: t(title),
      detail: t(message),
      life: duration,
    })
  }

  function info(title = 'messages.info.title', message = 'messages.info.title', duration = INFO_DURATION) {
    toast.add({
      severity: 'info',
      summary: t(title),
      detail: t(message),
      life: duration,
    })
  }

  return {
    success,
    warning,
    error,
    info,
  }
}
